// eslint-disable-next-line
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
// eslint-disable-next-line
import { useHistory, Link } from "react-router-dom";
import { Box } from "@mui/system";
// eslint-disable-next-line
import axios from "axios";
import { useSnackbar } from "notistack";
// eslint-disable-next-line
import React, { useState } from "react";
// eslint-disable-next-line
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

function CircularIndeterminate() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress />
    </Box>
  );
}



const Register = () => {
  // eslint-disable-next-line
  const { enqueueSnackbar } = useSnackbar();
  const [data,updateData] = useState({
    username:"",
    password :"",
    confirmPassword:"",
    
  })
  const history = useHistory();

  const [isLoading,setLoad]= useState(false)

  const handlingInput = (e)=>{
    const name = e.target.name;
    const value = e.target.value
    updateData({...data, [name]:value})
  }


  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  // eslint-disable-next-line
  const register =  async(formData) => {

    if(validateInput(formData)){
 
    //const POST_API = config.endpoint + '/auth/register';

     try {
      delete formData.confirmPassword
      setLoad(true);
      // eslint-disable-next-line
      const res =await axios.post(`${config.endpoint}/auth/register`, JSON.stringify(formData), {
        headers: { "Content-Type": "application/json" },
      });
      setLoad(false);
      enqueueSnackbar('success', { variant: "success" });
      history.push("/login", { from: "Register" });
      
      
    } catch (e) {
     // console.log(e + "hello")
      setLoad(false);
      if (e.response && e.response.status >= 400 ){
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      }
      else{
        enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.', { variant: "error" });
      }
    }
      
      
    }
  }
  
    
    //console.log(config.endpoint + '/auth/register')
    
    
  

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  // eslint-disable-next-line
  const validateInput = (data) => {
    const name = data.username;
    const Pass = data.password;
    const conf = data.confirmPassword;

    if (!name){
      enqueueSnackbar('Username is a required field.', { variant: "warning" }); 
    return false;
    }
    else if(name.split("").length<6){
      enqueueSnackbar('Username must be at least 6 characters', { variant: "warning" }); 
    return false;
    }
    else if(!Pass){
      enqueueSnackbar('Password is a required field.', { variant: "warning" }); 
    return false;
    }
    else if(Pass.split("").length<6){
      enqueueSnackbar('Password must be at least 6 characters', { variant: "warning" }); 
    return false;
    }
    else if(conf !== Pass){
      enqueueSnackbar('Passwords do not match.', { variant: "warning" }); 
    return false;

    }
    else{
    return true;
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={false} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={data.username}
            onChange={(e)=>handlingInput(e)}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={data.password}
            onChange={(e)=>handlingInput(e)}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={data.confirmPassword}
            onChange={(e)=>handlingInput(e)}
          />
          { !isLoading ?
           <Button className="button" variant="contained" onClick={()=>register(data)}>
            Register Now
           </Button>
           
           : <p className="loading"><CircularIndeterminate /></p>
            }
          <p className="secondary-action">
            Already have an account?{" "}
            
             
            <Link className="link" to="/login">
              Login here
            </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
